<xm-modal-close *ngIf="data.close" xmEscKey (escKeyPressed)="close('close')" (onClose)="close('close')"></xm-modal-close>
<div class="heading-container">
    <xm-media-image class="header-icon" [imageOptions]="imageOptions" size="height"></xm-media-image>
    <div class="heading-text">
        <h2 mat-dialog-title>{{ data.title }}</h2>
        <span class="subheading">{{ data.price }}</span>
        <button class="xm-btn-primary-light" (click)="close('primary')">{{ data.primaryButton }}</button>
    </div>
</div>
<div>
    <p [innerHtml]="data.titleBody"></p>
    <div *ngFor="let content of data.content" class="content-body">
        <xm-media-image *ngIf="content.iconOptions" class="content-icon" [imageOptions]="content.iconOptions" size="width"></xm-media-image>
        <h3>{{ content.title }}</h3>
        <div class="body">{{ content.description }}</div>
    </div>
    <p>{{ data.disclaimer }}</p>
    <cms-text class="more-details" [originalText]="data.footnote"></cms-text>
</div>
